// extracted by mini-css-extract-plugin
export default {"list":"ArticlesOverviewPanel_list__VGTPB","main":"ArticlesOverviewPanel_main__G1EDi","card":"ArticlesOverviewPanel_card__VXD3q"};